module.exports = __webpack_public_path__ + "static/media/testimonial-image-03.735bca47.png";